import React from 'react';
import { DropDown } from '../../../common/dropdown';
import { connect } from 'react-redux';
import { getDataFollowKeyByDot } from '../../../helpers/Common';
import { keyBy, isEmpty, isEqual } from 'lodash';
import Const from './Const';
import { changeIndustryDropDown, REDUCER_NAME } from '../reducer';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';

class DropDownIndustry extends React.Component {
  state = {
    lstDataIndustry: [],
    listIndustryByIcbCode: {},
    listIcbCodeIndustry: [],
  };

  componentDidMount() {
    const { listIndustryByIcbLevel } = this.props;
    this.setStateListDropdown(listIndustryByIcbLevel);
  }

  setStateListDropdown = listIndustryByIcbLevel => {
    let lstData = listIndustryByIcbLevel ? listIndustryByIcbLevel[3] : [];
    lstData = !isEmpty(lstData)
      ? [...Const.dropList, ...lstData]
      : Const.dropList;
    const listIndustryByIcbCode = keyBy(lstData, 'icbCode');
    const listIcbCodeIndustry = lstData.map(item =>
      getDataFollowKeyByDot(item, 'icbCode'),
    );
    this.setState({
      lstDataIndustry: lstData,
      listIndustryByIcbCode,
      listIcbCodeIndustry,
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const { listIndustryByIcbLevel } = this.props;
    const lstPrevListIndustry = prevProps
      ? prevProps.listIndustryByIcbLevel
      : [];
    if (!isEqual(listIndustryByIcbLevel, lstPrevListIndustry)) {
      this.setStateListDropdown(listIndustryByIcbLevel);
    }
  }

  render() {
    const { changeIndustryDropDown, industryId } = this.props;
    const { listIcbCodeIndustry, listIndustryByIcbCode } = this.state;
    return (
      <div className="filter-industry line-drop">
        <DropDown
          keyTitle="icbName"
          listKey={listIcbCodeIndustry}
          listDataByKey={listIndustryByIcbCode}
          currentKey={industryId + ''}
          change={value => {
            changeIndustryDropDown(value);
          }}
          isEditable={false}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    industryType: state[REDUCER_NAME].industryType,
    industryId: state[REDUCER_NAME].industryId,
    listIndustryByIcbLevel: state[COMMON_REDUCER_NAME].listIndustryByIcbLevel,
  };
};

const mapDispatchToProps = {
  changeIndustryDropDown,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DropDownIndustry);
